import React from 'react';
import coManagerLogo from '../../assets/co-manager-logo.svg';

function CoManagerAIIcon(props) {
  return <img src={coManagerLogo} alt="" {...props} />;
}

export default CoManagerAIIcon;
